var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeIn","leave-active-class":"animate__animated animate__fadeOut","mode":"out-in","duration":"500","appear":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }